import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

const Terms = () => {
  return (
    <div className="pb-16 bg-brand-bone min-h-screen" data-testid="terms-page">
      {/* Hero */}
      <section className="bg-brand-black/[0.03] py-12 md:py-20 border-b border-brand-cobalt/10">
        <div className="max-w-4xl mx-auto px-4">
          <Link 
            to="/" 
            className="inline-flex items-center gap-2 text-sm text-brand-cobalt hover:text-brand-cobalt/80 mb-6"
          >
            <ArrowLeft size={16} />
            Volver al inicio
          </Link>
          <h1 className="font-display text-3xl md:text-5xl tracking-tight mb-4 text-brand-black">
            Términos y Condiciones
          </h1>
          <p className="text-brand-black/60 text-lg">
            Última actualización: Diciembre 2025
          </p>
        </div>
      </section>

      {/* Content */}
      <section className="py-12 md:py-16">
        <div className="max-w-4xl mx-auto px-4">
          <div className="prose prose-lg max-w-none">
            <p className="text-brand-black/80 leading-relaxed mb-6">
              El acceso y uso del sitio web de Alphatica implica la aceptación de los presentes términos y condiciones.
            </p>
            <p className="text-brand-black/80 leading-relaxed mb-8">
              Al realizar una compra a través del sitio web, el usuario declara haber leído y aceptado estas condiciones.
            </p>

            <h2 className="font-display text-xl md:text-2xl mt-10 mb-4 text-brand-cobalt">Precios</h2>
            <p className="text-brand-black/80 mb-6">
              Todos los precios mostrados en el sitio web están expresados en <strong className="text-brand-black">moneda nacional mexicana (MXN)</strong> y 
              pueden estar sujetos a cambios sin previo aviso.
            </p>

            <h2 className="font-display text-xl md:text-2xl mt-10 mb-4 text-brand-cobalt">Disponibilidad</h2>
            <p className="text-brand-black/80 mb-4">
              Todos los productos están sujetos a disponibilidad.
            </p>
            <p className="text-brand-black/80 mb-4">
              En caso de que un producto adquirido no esté disponible, Alphatica podrá ofrecer:
            </p>
            <ul className="space-y-2 text-brand-black/80 mb-6">
              <li className="flex items-start gap-2">
                <span className="text-brand-petroleum">•</span>
                Reemplazo por producto similar
              </li>
              <li className="flex items-start gap-2">
                <span className="text-brand-petroleum">•</span>
                Reembolso del monto pagado
              </li>
              <li className="flex items-start gap-2">
                <span className="text-brand-petroleum">•</span>
                Cancelación del pedido
              </li>
            </ul>

            <h2 className="font-display text-xl md:text-2xl mt-10 mb-4 text-brand-cobalt">Uso del sitio</h2>
            <p className="text-brand-black/80 mb-6">
              El usuario se compromete a utilizar el sitio web únicamente con fines legales y de manera que 
              no afecte el funcionamiento del mismo.
            </p>

            <h2 className="font-display text-xl md:text-2xl mt-10 mb-4 text-brand-cobalt">Limitación de responsabilidad</h2>
            <p className="text-brand-black/80 mb-6">
              Alphatica no será responsable por daños indirectos derivados del uso del sitio web o de los 
              productos comercializados.
            </p>

            <div className="brand-card hybrid-glow p-6 rounded-lg mt-10">
              <h2 className="font-display text-xl mb-4 text-brand-black">Naturaleza de los productos</h2>
              <p className="text-brand-black/80">
                Las fragancias comercializadas por Alphatica son <strong className="text-brand-petroleum">productos de inspiración</strong> y no tienen 
                relación comercial ni afiliación con las marcas que puedan servir como referencia aromática.
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Terms;
